export const childIsRequired = (condition, parentValue) => {
    if (condition === null || condition === undefined) { return false; }
    if (condition === " " && !!parentValue) { return true; }
    if (condition === "" && !parentValue) { return true; }
    return condition === parentValue;
};

export const childIsVisible = (condition, parentValue) => {
    if (condition === null || condition === undefined) { return true; }
    if (condition === " " && !!parentValue) { return true; }
    if (condition === "" && !parentValue) { return true; }
    return condition === parentValue;
};